// Subcontractor-portal landing decision (extracted for regression testing).
//
// BUG (2026-07-01, tutorial 11 "Approving a Project for Owner"): the tour's
// "Open in Subcontractor Portal" step opened the embedded portal but landed on
// the DASHBOARD instead of the project-detail view, so `subProjectDetail` never
// loaded and the owner Approve button never rendered — the final "Click Approve"
// step dead-ended.
//
// ROOT CAUSE (React effect race in App.tsx): the "Open in Subcontractor Portal"
// handlers set subPortalView='projects' + subPortalProjectId + the hash, but did
// NOT set `pendingSubTabRef`. When `setActiveView('subcontractors')` fires the
// `[activeView]` reset effect, that effect reads `pendingSubTabRef.current`; when
// it is null it FORCES `setSubPortalView('dashboard')` (the "fresh load" default),
// overriding the 'projects' the handler just set. The reverse hash-sync then
// rewrites the hash to `/subcontractors/dashboard`, cementing the dashboard.
//
// FIX: the open-portal handlers now set `pendingSubTabRef.current = 'projects'`
// BEFORE `setActiveView`, and the reset effect routes through this helper: a
// pending tab wins, otherwise fall back to the dashboard default. Behavior is
// identical to before for every non-project entry (ref null => dashboard), and
// deep-links / the open-portal buttons now land + STAY on project detail.

export const SUB_PORTAL_DEFAULT_LANDING = 'dashboard'

/**
 * Resolve which sub-portal tab/view to land on when entering the Subcontractors
 * area. A caller-set pending tab (deep-link or "Open in Subcontractor Portal")
 * takes precedence; with nothing pending we land on the dashboard default.
 */
export function resolveSubPortalLanding(
  pendingTab: string | null | undefined,
  fallback: string = SUB_PORTAL_DEFAULT_LANDING,
): string {
  return pendingTab && pendingTab.trim() ? pendingTab : fallback
}
